var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NewPayment',{attrs:{"kind":"envelope","envelope_type":"cash"},on:{"close":function($event){return _vm.$router.push({ name: 'OpenEnvelopes' })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }